import axios from 'axios';

export default function postVxcPortfolioUpload(acceptedFiles, portfolioData, config) {
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
        'x-location-id': localStorage.getItem('locationId')
    };

    const url = config.postVxcPortfolioUpload;

    return dispatch => dispatch({
        type: 'VXC_FILE_UPLOAD_FETCH',
        payload: axios({ method: 'post', url, headers, data: { portfolioData } }).then((response) => {
            // now do a PUT request to the pre-signed URL
            axios.put(response.data.url, acceptedFiles[0]);
        })
    });
}


// WEBPACK FOOTER //
// ./src/actions/VXC/postVxcPortfolioUpload.js